import TreeSelector from './tree-selector'
import { WorkFlow, WorkbenchHeader, WorkbenchBody } from './layouts'
import { JcBasicProfile } from './profile'
import JcPreview from './preview'
import ElCascaderMulti from './multi-cascader'
import DetailPage from './detail-page/index.vue'
import DetailPageTitle from './detail-page/title.vue'
const components = {
  TreeSelector,
  JcBasicProfile,
  JcPreview,
  WorkFlow,
  WorkbenchHeader,
  WorkbenchBody,
  ElCascaderMulti,
  DetailPage,
  DetailPageTitle
}

const install = (Vue) => {
  for (let key in components) {
    if (components.hasOwnProperty(key)) {
      let component = components[key]
      if (component.install) component.install(Vue)
      else {
        Vue.component(component.name ? component.name : key, component)
      }
    }
  }
}

export default {
  install,
  ...components
}



// WEBPACK FOOTER //
// ./src/components/index.js